import { z } from "zod";

export const NewsLanguageSchema = z.enum(["ko", "en"]);
export type NewsLanguage = z.infer<typeof NewsLanguageSchema>;

export const NewsFeedTypeSchema = z.enum(["rss", "html"]);
export type NewsFeedType = z.infer<typeof NewsFeedTypeSchema>;

export const NewsSourceSchema = z.object({
  id: z.string().regex(/^[a-z0-9][a-z0-9_-]*$/),
  name: z.string().min(1),
  url: z.string().url(),
  homepageUrl: z.string().url().optional(),
  language: NewsLanguageSchema,
  feedType: NewsFeedTypeSchema,
  defaultTags: z.array(z.string()),
  enabled: z.boolean(),
  robotsAllowed: z.boolean(),
  robotsCheckedAt: z.string(),  // ISO 8601 date
  copyrightNote: z.string(),
  notes: z.string().optional(),
});
export type NewsSource = z.infer<typeof NewsSourceSchema>;

export const NewsSourcesFileSchema = z.object({
  sources: z.array(NewsSourceSchema),
});
export type NewsSourcesFile = z.infer<typeof NewsSourcesFileSchema>;
